import { render, staticRenderFns } from "./BedRailCheck.vue?vue&type=template&id=ef082722&scoped=true&"
import script from "./BedRailCheck.vue?vue&type=script&lang=js&"
export * from "./BedRailCheck.vue?vue&type=script&lang=js&"
import style0 from "./BedRailCheck.vue?vue&type=style&index=0&id=ef082722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef082722",
  null
  
)

export default component.exports